export default __webpack_public_path__ + "static/media/NewLogoCW.70b09bf2.png";